import request from '@/config/axios'

export const getDictDataList = (type: string) => {
  return request.get({
    url: '/system/dict-data/type?type='+type
  })
}